<template>
  <a-tabs class="menu-tag-list" :activeKey="currentOp" @change="handleTagChange">
    <a-tab-pane v-for="item in tagList" :key="item.op" :tab="item.tag" :disabled="item.disabled" />
  </a-tabs>
</template>

<script>
export default {
  name: "TagMenu",
  props: ['tagList', 'currentOp', 'handleTagClick'],
  model: {
    prop: 'currentOp',
    event: 'change'
  },
  methods: {
    handleTagChange(tag) {
      if (this.handleTagClick) {
        this.handleTagClick(tag);
      }
      this.$emit('change', tag);
    }
  }
}
</script>

<style>
.menu-tag-list .ant-tabs-bar {
  margin-bottom: 0;
  border-color: rgba(0, 0, 0, 0.1);
}

.menu-tag-list .ant-tabs-nav {
  display: block;
  text-align: center;
}

.menu-tag-list .ant-tabs-nav > div {
  display: flex;
}

.menu-tag-list .ant-tabs-bar .ant-tabs-tab {
  flex-grow: 1;
  width: 1px;
  margin-right: 0;
  padding: 12px 0;
}

.menu-tag-list .ant-tabs-tab-active {
  color: #007eff;
}

.menu-tag-list .ant-tabs-ink-bar {
  background-color: #007eff;
}

.menu-tag-list .ant-tabs-bar .ant-tabs-tab-disabled {
  color: rgba(0, 0, 0, 0.15);
}
</style>
